import { Box, Typography } from "@mui/material";
import { useContext } from "react";
import { themeContext } from "../context";

export default function EducationSection() {
    const theme = useContext(themeContext);
    const darkMode = theme.state.darkMode;

    return (
        <Box
            id="Education"
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: { xs: 3, md: 35},
                height: '60vh',
                mb: 8,
                pt: 5,
                color: darkMode ? 'white' : 'black',
                mt: { xs: 20, md: 15 }
            }}
        >
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Box
                    sx={{
                        width: '5.2rem',
                        height: '5rem',
                        background: 'white',
                        borderRadius: '50%',
                        position: 'relative',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '1.5rem',
                        mb: 2,
                        '&::before': {
                            content: '""',
                            borderRadius: '50%',
                            backgroundImage: 'linear-gradient(to bottom, #87e6fb 0%, #ffc05c 100%)',
                            position: 'absolute',
                            top: '-8px',
                            left: '-8px',
                            bottom: '-8px',
                            right: '-8px',
                            zIndex: -1,
                            boxShadow: 'var(--boxShadow)'
                        }
                    }}
                >
                    80.8%
                </Box>
                <Typography variant='h5'
                    sx={{
                        color: darkMode ? 'white' : 'inherit',
                        fontWeight: 'bold',
                        
                    }}
                >
                    Bachelor
                </Typography>
                <Typography sx={{ color: 'var(--orange)', fontWeight: 'bold' }} variant='h5'>
                    Computer Application
                </Typography>
            </Box>

            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Box
                    sx={{
                        width: '5.2rem',
                        height: '5rem',
                        background: 'white',
                        borderRadius: '50%',
                        position: 'relative',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '1.5rem',
                        mb: 2,
                        '&::before': {
                            content: '""',
                            borderRadius: '50%',
                            backgroundImage: 'linear-gradient(to bottom, #87e6fb 0%, #ffc05c 100%)',
                            position: 'absolute',
                            top: '-8px',
                            left: '-8px',
                            bottom: '-8px',
                            right: '-8px',
                            zIndex: -1,
                            boxShadow: 'var(--boxShadow)'
                        }
                    }}
                >
                    83.2%
                </Box>
                <Typography
                    sx={{
                        color: darkMode ? 'white' : 'inherit',
                        fontWeight: 'bold'
                    }}
                    variant='h5'
                >
                    Masters
                </Typography>
                <Typography sx={{ color: 'var(--orange)', fontWeight: 'bold' }} variant='h5'>
                    Computer Application
                </Typography>
            </Box>
        </Box>
    );
}